var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('instructor-form',{attrs:{"loading":_vm.getIsLoading},on:{"on-submit":_vm.onSave}})}
var staticRenderFns = []

export { render, staticRenderFns }